module.exports = __webpack_public_path__ + "img/infoIcon.8f9f255d.svg";